// src/RecipeDB/RecetarioCard.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './RecetarioCard.css';

/**
 * Tarjeta de recetario con mosaico de hasta 4 imágenes de portada.
 * Props: recetario { id, nombre, descripcion, coverImages[], recetaIds[] }
 * onDelete: callback para eliminar (solo owner)
 */
const RecetarioCard = ({ recetario, isOwner, onDelete }) => {
  const navigate = useNavigate();
  const covers   = (recetario.coverImages || []).slice(0, 4);
  const count    = recetario.recetaIds?.length ?? 0;

  return (
    <div className="recetario-card" onClick={() => navigate(`/recetario/${recetario.id}`)}>

      {/* Mosaico de portada */}
      <div className={`recetario-card__mosaic mosaic-${Math.min(covers.length, 4) || 0}`}>
        {covers.length > 0
          ? covers.map((url, i) => (
              <img key={i} src={url} alt="" className="recetario-card__cover-img" />
            ))
          : <div className="recetario-card__cover-placeholder">📚</div>
        }
      </div>

      {/* Info */}
      <div className="recetario-card__body">
        <span className="recetario-card__name">{recetario.nombre}</span>
        <span className="recetario-card__count">{count} {count === 1 ? 'receta' : 'recetas'}</span>
        {recetario.descripcion ? (
          <span className="recetario-card__desc">{recetario.descripcion}</span>
        ) : null}
      </div>

      {/* Acciones owner */}
      {isOwner && (
        <button
          className="recetario-card__delete"
          title="Eliminar recetario"
          onClick={e => { e.stopPropagation(); onDelete(recetario); }}
        >
          🗑️
        </button>
      )}
    </div>
  );
};

export default RecetarioCard;
